import React, { useEffect, useRef, useState } from "react";

import {
    Box,
    TextField,
    Typography,
} from '@mui/material';

import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        'input': {
            fontSize: '12px'
        },
        '& fieldset': {
            borderColor: 'rgba(139, 142, 146, 1)',
            borderWidth: 1,
        },
        '&:hover fieldset': {
            borderColor: 'rgba(178, 235, 177, 1)',
            borderWidth: 1,
        },
        '&.Mui-focused fieldset': {
            borderColor: 'rgba(178, 235, 177, 1)',
            borderWidth: 1,
        },
        '&.Mui-disabled fieldset': {
            borderColor: 'rgba(175, 175, 175, 1)',
            borderWidth: 1,
        },
        '&.Mui-disabled input': {
            color: 'rgba(175, 175, 175, 1)',
            WebkitTextFillColor: 'rgba(175, 175, 175, 1)', // For Chrome/Safari
        },
    },
}));

/**
 * 
 * @param {{description: string, disabled: boolean, label: string, onChange: function, original: string, value: string}} props 
 *
 */
function SettingsTextField(props) {

    const {
        description='',
        disabled=false,
        label='',
        onChange = () => {},
        original='',
        value='',
    } = props

    const [commitValue, setCommitValue] = useState(value);
    const [editValue, setEditValue] = useState(value);
    const [focused, setFocused] = useState(false);
    const [uncommittedChanges, setUncommittedChanges] = useState(false);

    const discardRef = useRef(false);

    useEffect(() => {
        setCommitValue(value);
        setEditValue(value);
    }, [value]);

    useEffect(() => {
        original === commitValue ? setUncommittedChanges(false) : setUncommittedChanges(true);
    }, [commitValue, original])

    function handleChange(newValue) {
        setCommitValue(newValue);
        setEditValue(newValue);
        onChange(newValue);
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            m={1}
            position='relative'
        >
            {
                uncommittedChanges && 
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    mx={-1}
                    my={0.7}
                >
                    <Box
                        width={5}
                        height={5}
                        borderRadius={5}
                        backgroundColor={'rgba(255, 193, 7, 1)'} // warning color (amber)
                    />
                </Box>
            }
            <Typography
                variant="subtitle2"
                fontWeight={900}
                fontSize="12px"
                sx={{
                    color: disabled ? 'rgba(175, 175, 175, 1)'
                        : focused ? 'rgba(178, 235, 177, 1)'
                        : 'rgba(255, 255, 255, 1)'
                }}
            >
                {label}
            </Typography>
            <Typography
                variant="subtitle2"
                fontWeight={600}
                fontSize="11px"
                color="rgb(150, 150, 150)"
            >
                {description}
            </Typography>
            <Box width="250px">
                <StyledTextField
                    fullWidth
                    disabled={disabled}
                    variant="outlined"
                    size="small"
                    sx={{ input: { color: 'white' } }}
                    value={editValue}
                    onChange={(event) => setEditValue(event.target.value)}
                    onFocus={() => {
                        setFocused(true);
                    }}
                    onBlur={(e) => {
                        setFocused(false);
                        if(discardRef.current === true) {
                            handleChange(commitValue)
                            discardRef.current = false
                        }
                        else {
                            handleChange(editValue)
                        }
                    }}
                    onKeyDown={(e) => {
                        if (['Enter', 'NumpadEnter', 'Tab'].includes(e.key)) {
                            e.target.blur();
                        }
                        if (e.key === 'Escape') {
                            discardRef.current = true // Discard the current edit
                            e.target.blur()
                        }
                    }}
                />

            </Box>
        </Box>
    );
}

export default SettingsTextField;